// Third party
import { useSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';

// Hooks
import { ProfileController } from '../../../services';
import { useAppDispatch, useAppSelector } from '../../useAppStore';

// Components
import { useError } from '../../useError';
import { TAxiosError } from '../../../types/responses';
import { TBiometricDataUpdateReq } from '../../../types/requests';
import { getProfileInfo, profileDataActions } from '../../../store';
import { TBiometricData, TProfileInfo, TShooterProfileInfo } from '../../../types';

export function useUpdateBiometricDataAPI() {
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();
  const { enqueueSnackbar } = useSnackbar();
  const profileInfo = useAppSelector<TProfileInfo | TShooterProfileInfo | null>(getProfileInfo);

  const updateBiometricDataAPI = async (data: TBiometricDataUpdateReq) => {
    const payload = {
      dominant_eye: data.dominant_eye,
      dominant_hand: data.dominant_hand,
    };

    return await ProfileController().updateBiometricData(payload);
  };

  return useMutation({
    mutationFn: updateBiometricDataAPI,
    onSuccess: async (_, variables) => {
      enqueueSnackbar('Physiological Data Successfully Updated!', {
        variant: 'success',
      });

      const biometricData: TBiometricData = {
        dominant_eye: variables.dominant_eye ?? '',
        dominant_hand: variables.dominant_hand ?? '',
        user_id: profileInfo?.id ?? 0,
      };

      dispatch(profileDataActions.setBiometricData(biometricData));
    },
    onError: async (error: TAxiosError) => {
      await handleReqError(error);
    },
  });
}
